export * from './useModuleScope';
